module.exports = __webpack_public_path__ + "img/state0.ae8b0a48.png";